import { SupportWrapper } from '../support/SupportStyles';
export const FAQWrapper = SupportWrapper;
